import React from 'react'
import Info from '../About/Info'
import Hero from '../About/Hero'
import { Helmet } from 'react-helmet-async'

const About = () => {
    return (
        <>
            <Helmet>
                <title> About-Us - Website Design & Web Development Company In Nagpur</title>
                <link rel="canonical" href="/about"></link>
                <meta name="description"
                    content="Best Digital Marketing company in Nagpur. Bluecoder is Nagpur's well established web design, web app development and SEO company and spearheaded by CEO Pravin Tidake"
                    data-rh="true" />

                <meta name="keywords"
                    content="Pravin Tidake, Web Solutions in Anravati, web site design company Nagpur, best digital marketing company Nagpur, It company Nagpur, Software company Nagpur, ecommerce development company Nagpur, website devlopment Nagpur" />
            </Helmet>
            <Hero />
            <Info />
        </>
    )
}

export default About